// guards/auth.js
export function checkAuth({ store, to }) {
  const isLogged = store.state.auth.isLogged;
  const isPublic = to.matched.some(r => r.meta.public);
  const isLoginPage = to.name === 'login';

  // 1. PROTECCIÓN DE RUTAS PRIVADAS
  // Si no está logueado y la ruta NO es pública, al Login.
  if (!isLogged && !isPublic) {
    console.log("🔒 [AuthGuard] Acceso privado: Redirigiendo a Login");
    return { name: 'login' };
  }

  // 2. PREVENCIÓN DE REDUNDANCIA
  // Si YA está logueado e intenta entrar al Login, lo enviamos a su Dashboard según rol.
  if (isLogged && isLoginPage) {
    const role = store.state.auth.user.role || [];
    console.log("🔓 [AuthGuard] Usuario ya autenticado: Saltando Login");

    if (role.includes('admin') || role.includes('owner')) {
      return { path: '/admin' };
    }
    if (role.includes('produccion')) {
      return { name: 'empresa.produccion.cola' };
    }
    if (role.includes('employee')) {
      return { name: 'pos.home' };
    }

    return { path: '/empresa' };
  }

  // 3. CONTINUAR
  // Si es una ruta pública o está logueado y va a una ruta privada, permitimos pasar al siguiente guard.
  return null;
}